/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import React from "react";
import CircularProgress from "@mui/material/CircularProgress";

const Loading = () => {
    return (
      <div
        css={css`
          display: flex;
          justify-content: center;
          align-items: center;
          height: 100vh;
        `}
      >
        <div>
          <CircularProgress></CircularProgress>
        </div>
      </div>
    );
  };
  
  export default Loading;